import styles from "./IconMenu.module.css";
import Icons from "../Icons/Icons";
function IconMenu() {
  return (
    <nav className={styles.container}>
      <ul className={styles.IconMenu}>
        <Icons />
      </ul>
    </nav>
  );
}

export default IconMenu;
